<template>
  <div ref="chargeEchart" class="ec-canvas"></div>
</template>
<script>
import { echartsJS } from "@/common/old/public/add-js.js";
import statisticsData from '../../my-statistics-data'
export default {
  name: "pi-echarts-line",
  components: {},
  data() {
    return {};
  },
  props: {
    chartData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: ''
    },
  },
  watch : {
    'chartData': function () {
      this.$nextTick(()=>{
        this.addEchart();
      })
      
    }
  },
  mounted() {
    this.addEchart();
  },
  methods: {
    async addEchart() {
      await echartsJS();
      this.$nextTick(()=>{
        this.getLineOption();
      })
      
    },
    getLineOption() {
      let unit = '';
      let name = '';
      if(this.type == statisticsData.cententKey.memberMoney){
        unit = '(单位:元)';
        name = '金额';
      }else{
        unit = '(单位:kWh)';
        name = '充电量';
      }
      var option = {
        title: {
          left: 10,
          top: 10,
          text: unit,
          textStyle: {
            //文字颜色
            color: "#999",
            //字体风格,'normal','italic','oblique'
            fontStyle: "normal",
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: "400",
            //字体系列
            fontFamily: "PingFangSC-Regular, PingFang SC;",
            //字体大小
            fontSize: 10,
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: [name],
          top: "10",
          right: "10",
          itemWidth: 15,
          itemHeight: 2,
        },
        grid: {
          left: "10",
          right: "10",
          bottom: "10",
          top: "39",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.chartData.nameArr, //['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          axisTick: { alignWithLabel: true }, // 控制样式里的X轴字在中间距离Y轴还有点距离
          axisLine: {
            lineStyle: {
              color: "#eeeeee",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#333", // 修改X轴文字的颜色
              fontSize: "10px", // 修改X轴文字大小
            },
          },
          splitLine: {
            //网格线
            lineStyle: {
              color: "#eeeeee",
              type: "solid", //设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, //隐藏或显示
          },
        },
        yAxis: {
          type: "value",
          axisLine: { show: false }, //是否展示y轴坐标竖线
          axisTick: { show: false }, //是否展示y轴坐标刻度
          // 字体颜色
          axisLabel: {
            color: "#333",
            fontSize: "10px",
          },
          // 分割线
          splitLine: {
            show: true,
            lineStyle: {
              color: "#eeeeee",
              type: "solid",
            },
          },
        },
        color: ["#14CC80"],
        series: [
          {
            name: name,
            data: this.chartData.valueArr, //[150, 230, 224, 218, 135, 147, 260],
            type: "line",
            showSymbol: true, //是否默认展示圆点
            symbol: "circle", //设定为实心点
            symbolSize: 6, //设定实心点的大小
          },
        ],
      };
      let myChart = window.echarts.init(this.$refs.chargeEchart);
      myChart.setOption(option, true);
    },
  },
};
</script>

<style lang="less" scoped>
.ec-canvas {
  height: 100%;
  height: 100%;
}
</style>
